
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useState } from 'react';
import ContentPasteSearchOutlinedIcon from '@mui/icons-material/ContentPasteSearchOutlined';
import { makeStyles } from '@material-ui/core';
import { Avatar, Box, Card, Grid, IconButton, InputBase, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import api from '../services/api';
import Loading from '../load/loading';
import MessageError from '../messages/messageError';
import ImagemEdit from '../utils/imagemEdit';
import CloseIcon from '@mui/icons-material/Close';
import InfoFieldGroup from '../utils/InfoField/InfoFieldGroup';
// import StatusEstabelecimento from '../utils/statusEstabelecimento';


const useStales = makeStyles({
    icone: {
        margin: 7,
        color: '#fff'
    },
    hover: { '&:hover': { backgroundColor: '#d2d6ff', cursor: 'pointer', } }
})

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
}));

export default function BuscaEstabelecimento(props) {
    const classes = useStales()
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState('');
    const [pesquisa, setPesquisa] = useState('');
    const [openLoad, setOpenLoad] = useState(false);
    const [messageError, setMessageError] = useState('');
    const [select, setSelect] = useState('')

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const searchEstabelecimento = async (e) => {
        e.preventDefault();
        handleClickOpen();
        setPesquisa('');
        setMessageError('');
        setOpenLoad(true);

        try {
            const response = await api.post(`/estabelecimento/search?perPage=10`, { search })
            setPesquisa(response.data.estabelecimentos);
            setOpenLoad(false)

        } catch (error) {
            if (error.message === "Network Error") {
                setMessageError(error.message)
            }
            setOpenLoad(false)
            setPesquisa('');
            setMessageError(error.response.data.message);
        }
    }

    return (
        <div>
            <Typography noWrap sx={{ display: { xs: 'none', md: 'inline' } }}>
                {/* <span style={{ color: '#fff', fontSize: 13 }}>PESQUISAR</span> */}
                <InputBase
                    style={{ fontSize: 12, color: '#fff', border: '1px solid #fff', borderRadius: 20, backgroundColor: 'rgba(255, 255, 255, 0.15)', paddingLeft: 10, paddingRight: 10 }}
                    required
                    // autoFocus
                    // placeholder="Pesquisar pelo nome ou NIF"
                    inputProps={{ 'aria-label': 'Filtrar lista' }}
                    onChange={(e) => { setSearch(e.target.value) }}
                />
                <IconButton disabled={!search} onClick={searchEstabelecimento} >
                    <img src="/icones/lupacnp.svg" width={25} alt="search" />
                </IconButton>
            </Typography>

            <BootstrapDialog
                fullWidth
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogContent >
                    {messageError && <MessageError message={messageError} />}

                    {select && <IconButton color='error' title="fechar" style={{ position: 'absolute', right: 5, fontWeight: 'bold' }} onClick={() => setSelect('')}> <CloseIcon /></IconButton>}

                    <Box m={2}>
                        <form onSubmit={searchEstabelecimento} style={{ display: 'flex', }}>
                            <InputBase
                                style={{ maxWidth: 560, marginLeft: 'auto', marginRight: 'auto' }}
                                required
                                autoFocus
                                sx={{ ml: 1, flex: 1 }}
                                placeholder="PESQUISAR ESTABELECIMENTO"
                                onChange={(e) => setSearch(e.target.value)}
                            />
                            <IconButton type="submiy" aria-label="search">
                                <ContentPasteSearchOutlinedIcon />
                            </IconButton>
                        </form>
                    </Box>

                    {openLoad && <Loading text={'A pesquisar estabelecimento'} />}


                    {(pesquisa && !select) &&
                        <Card variant="outlined">
                            <TableContainer >
                                <Table id="myTable" size="small" stickyHeader aria-label="sticky table">
                                    <TableHead >
                                        <TableRow>
                                            <TableCell ><Typography noWrap> <strong>Imagem</strong></Typography></TableCell>
                                            <TableCell ><Typography noWrap> <strong>Nome</strong></Typography></TableCell>
                                            <TableCell ><Typography noWrap> <strong>Director Técnico</strong></Typography></TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {pesquisa.map((pesquisa) => (
                                            <TableRow key={pesquisa?._id} className={classes.hover} onClick={() => setSelect(pesquisa)} title={pesquisa?.nome}>
                                                <TableCell component="th" scope="row">
                                                    <Avatar variant='square' src={pesquisa?.logo} alt={pesquisa?.nome} />
                                                </TableCell>
                                                <TableCell  >{pesquisa?.nome}</TableCell>
                                                <TableCell  >{pesquisa?.directorTecnico?.dadosPessoais?.nome}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Card>
                    }


                    {select &&
                        <Grid container>
                            <Grid item marginRight={2}>
                                <ImagemEdit
                                    data={select}
                                    url={'/estabelecimento/change-logo'}
                                    local={'estabelecimentoId'}
                                />
                            </Grid>

                            <Grid xs item>
                                <InfoFieldGroup
                                    fields={
                                        [
                                            // { label: 'Estado', value: dadosEstabelecimento?.status, editable: false, },
                                            { label: 'Nome', value: select?.nome, editable: false, },
                                            // { label: 'E-mail', value: select?.email, editable: false, },
                                            { label: 'Estabelecimento', value: select?.tipo?.designacao, editable: false, },
                                            // { label: 'Tipo de entrada', value: select?.tipoEntrada, editable: false, },
                                            // { label: 'Número de processo', value: select?.numeroProcesso ?? select?.numeroEntrada, editable: false, },
                                            // { label: 'Número de entrada', value: select?.numeroEntrada, editable: false, },
                                            // { label: 'Data de entrada', value: select?.dataEntrada ?? <DateHora date={select?.createdAt} />, editable: false, },
                                            { label: 'Rua / Avenida', value: select?.rua, editable: false, },
                                            { label: 'Bairro', value: select?.bairro, editable: false, },
                                            { label: 'Município', value: select?.municipio, editable: false, },
                                            { label: 'Provincia', value: select?.provincia, editable: false, },
                                        ]
                                    } />
                            </Grid>
                        </Grid>
                    }

                </DialogContent>
            </BootstrapDialog>
        </div>
    );
}
